var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            id: "content-form",
            design: "v3",
            "show-title": false,
            "show-footer": false,
          },
          on: {
            cancel: function ($event) {
              return _vm.$emit("cancel")
            },
          },
        },
        [
          _c("div", { staticClass: "pcf-modal" }, [
            _c("div", { staticClass: "pcf-header" }, [
              _c("div", { staticClass: "pcf-header__title" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
            ]),
            _vm._v(" "),
            _vm.errors.items.length && _vm.submitClicked
              ? _c("div", { staticClass: "pcf-alert" }, [
                  _vm._v(
                    "\n            Gerekli alanları doldurmanız gerekmektedir\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "pcf-form",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.handleSubmit.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "pcf-section" }, [
                  _vm.isChild
                    ? _c("div", { staticClass: "pcf-field" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("message.contentType"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.content.type,
                                expression: "content.type",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            class: {
                              "pcf-input-error": _vm.errors.has(
                                _vm.$t("message.contentType")
                              ),
                            },
                            attrs: {
                              "data-vv-as": _vm.$t("message.contentType"),
                              name: _vm.$t("message.contentType"),
                            },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.content,
                                  "type",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { domProps: { value: undefined } }, [
                              _vm._v(_vm._s(_vm.$t("message.pickOne")) + "..."),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "ALT" } }, [
                              _vm._v(_vm._s(_vm.isMac ? "CTRL" : "ALT")),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "TAB" } }, [
                              _vm._v("TAB"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "HASH" } }, [
                              _vm._v("#HASH"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "TITLE" } }, [
                              _vm._v(_vm._s(_vm.$t("message.title"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.errors.has(_vm.$t("message.contentType"))
                          ? _c("span", { staticClass: "pcf-field-error" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.errors.first(
                                      _vm.$t("message.contentType")
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showGroupSelect
                    ? _c("div", { staticClass: "pcf-field" }, [
                        _c("label", [_vm._v(_vm._s(_vm.$t("message.group")))]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.content.parentId,
                                expression: "content.parentId",
                              },
                            ],
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.content,
                                  "parentId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                            },
                          },
                          [
                            _c("option", { domProps: { value: null } }, [
                              _vm._v(_vm._s(_vm.$t("message.pickOne")) + "..."),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.parentGroups, function (opt) {
                              return _c(
                                "option",
                                {
                                  key: opt.value,
                                  domProps: { value: opt.value },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(opt.text) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAlt
                    ? _c("div", { staticClass: "pcf-field" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("message.shortcutChar"))),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.content.letter,
                              expression: "content.letter",
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value:
                                "required|alpha_num|length:1|excluded:e,d,f,z,a,x,c,v,w,t,n",
                              expression:
                                "'required|alpha_num|length:1|excluded:e,d,f,z,a,x,c,v,w,t,n'",
                            },
                          ],
                          class: {
                            "pcf-input-error": _vm.errors.has(
                              _vm.$t("message.shortcutChar")
                            ),
                          },
                          attrs: {
                            "data-vv-as": _vm.$t(_vm.content.letter),
                            name: _vm.$t("message.shortcutChar"),
                            placeholder: _vm.$t("message.writeSomething"),
                            autocomplete: "off",
                            type: "text",
                          },
                          domProps: { value: _vm.content.letter },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.content,
                                "letter",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.errors.has(_vm.$t("message.shortcutChar"))
                          ? _c("span", { staticClass: "pcf-field-error" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.errors.first(
                                      _vm.$t("message.shortcutChar")
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ])
                          : _c("small", { staticClass: "pcf-hint" }, [
                              _vm._v(
                                _vm._s(_vm.$t("message.shortcut")) +
                                  ": alt + " +
                                  _vm._s(_vm.content.letter)
                              ),
                            ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isTab
                    ? _c("div", { staticClass: "pcf-inline" }, [
                        _c("div", { staticClass: "pcf-field" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.letterSequence"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.content.letter,
                                expression: "content.letter",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                            ],
                            class: {
                              "pcf-input-error": _vm.errors.has(
                                _vm.$t("message.letterSequence")
                              ),
                            },
                            attrs: {
                              "data-vv-as": _vm.$t("message.letterSequence"),
                              name: _vm.$t("message.letterSequence"),
                              placeholder: _vm.$t("message.exampleText"),
                              autocomplete: "off",
                              type: "text",
                            },
                            domProps: { value: _vm.content.letter },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.content,
                                  "letter",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.has(_vm.$t("message.letterSequence"))
                            ? _c("span", { staticClass: "pcf-field-error" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.errors.first(
                                        _vm.$t("message.letterSequence")
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pcf-tab-divider" }, [
                          _vm._v("TAB"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pcf-field" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.shorcutKey"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.content.number,
                                expression: "content.number",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|length:1",
                                expression: "'required|length:1'",
                              },
                            ],
                            class: {
                              "pcf-input-error": _vm.errors.has(
                                _vm.$t("message.shorcutKey")
                              ),
                            },
                            attrs: {
                              "data-vv-as": _vm.$t("message.shorcutKey"),
                              name: _vm.$t("message.shorcutKey"),
                              placeholder: _vm.$t("message.anyChar"),
                              autocomplete: "off",
                            },
                            domProps: { value: _vm.content.number },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.content,
                                  "number",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.errors.has(_vm.$t("message.shorcutKey"))
                            ? _c("span", { staticClass: "pcf-field-error" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.errors.first(
                                        _vm.$t("message.shorcutKey")
                                      )
                                    ) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isHash
                    ? _c("div", { staticClass: "pcf-field" }, [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("message.hashText"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pcf-prefix-input" }, [
                          _c(
                            "span",
                            { staticClass: "pcf-prefix-input__prefix" },
                            [_vm._v("#")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.content.hash,
                                expression: "content.hash",
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|alpha_num",
                                expression: "'required|alpha_num'",
                              },
                            ],
                            class: {
                              "pcf-input-error": _vm.errors.has(
                                _vm.$t("message.hashText")
                              ),
                            },
                            attrs: {
                              "data-vv-as": _vm.$t(_vm.content.hash),
                              name: _vm.$t("message.hashText"),
                              placeholder: _vm.$t("message.exampleHash"),
                              autocomplete: "off",
                              type: "text",
                            },
                            domProps: { value: _vm.content.hash },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.content,
                                  "hash",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.errors.has(_vm.$t("message.hashText"))
                          ? _c("span", { staticClass: "pcf-field-error" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.errors.first(_vm.$t("message.hashText"))
                                  ) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pcf-section" }, [
                  _c("div", { staticClass: "pcf-tabs-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "pcf-tabs" },
                      _vm._l(_vm.systemLanguages, function (lang) {
                        return _c(
                          "div",
                          {
                            key: lang,
                            staticClass: "pcf-tab",
                            class: {
                              active: _vm.activeTab === lang,
                              "pcf-tab--error": _vm.hasLangError(lang),
                            },
                            on: {
                              click: function ($event) {
                                _vm.activeTab = lang
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(lang.toUpperCase()) +
                                "\n                            "
                            ),
                            _vm.hasLangError(lang)
                              ? _c("span", {
                                  staticClass: "pcf-tab__error-dot",
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pcf-tab-actions" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: _vm.$t(
                                  "message.vtippyTranslateButton"
                                ),
                              },
                              expression:
                                "{ content: $t('message.vtippyTranslateButton') }",
                            },
                          ],
                          staticClass: "pcf-icon-btn",
                          class: { "pcf-icon-btn--loading": _vm.isTranslating },
                          on: {
                            click: function ($event) {
                              !_vm.isTranslating &&
                                _vm.translateToOthers(_vm.activeTab)
                            },
                          },
                        },
                        [
                          !_vm.isTranslating
                            ? _c("md-icon", [_vm._v("translate")])
                            : _c("md-icon", { staticClass: "pcf-spinner" }, [
                                _vm._v("hourglass_empty"),
                              ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: _vm.$t(
                                  "message.vtippyTranslateClearButton"
                                ),
                              },
                              expression:
                                "{ content: $t('message.vtippyTranslateClearButton') }",
                            },
                          ],
                          staticClass: "pcf-icon-btn",
                          on: {
                            click: function ($event) {
                              return _vm.clearOthers(_vm.activeTab)
                            },
                          },
                        },
                        [_c("md-icon", [_vm._v("clear")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: { content: "Yeni Dil Ekle" },
                              expression: "{ content: 'Yeni Dil Ekle' }",
                            },
                          ],
                          staticClass: "pcf-icon-btn",
                          on: { click: _vm.showAddLangModal },
                        },
                        [_c("md-icon", [_vm._v("add")])],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pcf-tab-content" }, [
                    _c("div", { staticClass: "pcf-field" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("message.titleContentForm"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.contentByLang[_vm.activeTab].name,
                            expression: "contentByLang[activeTab].name",
                          },
                        ],
                        attrs: {
                          placeholder: _vm.$t("message.titleContentForm"),
                          type: "text",
                        },
                        domProps: {
                          value: _vm.contentByLang[_vm.activeTab].name,
                        },
                        on: {
                          blur: function ($event) {
                            return _vm.validateLang(_vm.activeTab)
                          },
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.contentByLang[_vm.activeTab],
                              "name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pcf-field" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("message.message"))),
                        ]),
                        _vm._v(" "),
                        _c("quill-editor", {
                          ref: "quillEditor",
                          staticClass: "pcf-editor",
                          attrs: { options: _vm.editorOptions },
                          on: {
                            blur: function ($event) {
                              return _vm.validateLang(_vm.activeTab)
                            },
                            ready: _vm.onQuillReady,
                          },
                          model: {
                            value: _vm.contentByLang[_vm.activeTab].content,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.contentByLang[_vm.activeTab],
                                "content",
                                $$v
                              )
                            },
                            expression: "contentByLang[activeTab].content",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pcf-footer" }, [
                  _c("div", { staticClass: "pcf-status" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("report.status")))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "pcf-toggle",
                        on: {
                          click: function ($event) {
                            _vm.content.isActive = !_vm.content.isActive
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pcf-toggle__track",
                            class: { active: _vm.content.isActive },
                          },
                          [_c("div", { staticClass: "pcf-toggle__thumb" })]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "pcf-toggle__label" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.content.isActive
                                  ? _vm.$t("message.active")
                                  : _vm.$t("message.passive")
                              ) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pcf-actions" },
                    [
                      _c(
                        "SupsisButton",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$emit("cancel")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.cancel")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          attrs: { primary: "", disabled: _vm.loading },
                          on: { click: _vm.handleSubmit },
                        },
                        [
                          _vm.loading
                            ? _c("md-icon", [_vm._v("hourglass_empty")])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.editMode
                                      ? _vm.$t("message.update")
                                      : _vm.$t("message.save")
                                  )
                                ),
                              ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.showLangModal
            ? _c(
                "Modal2",
                {
                  attrs: {
                    "show-footer": false,
                    title: _vm.$t("message.selectALanguage"),
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.showLangModal = false
                    },
                  },
                },
                [
                  _c("div", { staticClass: "pcf-lang-modal" }, [
                    _c("div", { staticClass: "pcf-field" }, [
                      _c("label", [_vm._v(_vm._s(_vm.$t("message.language")))]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newLang,
                              expression: "newLang",
                            },
                          ],
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.newLang = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v(_vm._s(_vm.$t("message.pickOne")) + "..."),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.availableLanguages, function (l) {
                            return _c(
                              "option",
                              { key: l.code, domProps: { value: l.code } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(l.label) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pcf-lang-modal__actions" },
                      [
                        _c(
                          "SupsisButton",
                          {
                            on: {
                              click: function ($event) {
                                _vm.showLangModal = false
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("message.cancel")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "SupsisButton",
                          {
                            attrs: { primary: "", disabled: !_vm.newLang },
                            on: { click: _vm.addLanguage },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("message.save")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }